<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"><img alt="0310263182_content_0003_001" id="d12e59" src="images/0310263182_content_0003_001.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Coll_ISBN0310862558_epub_c3_r1.vue?0d961afb